import { Vec2 } from './vec2.js';

export class Mat2 {
  constructor(
    public readonly a: number,
    public readonly b: number,
    public readonly c: number,
    public readonly d: number,
  ) {}

  static readonly IDENTITY = new Mat2(1, 0, 0, 1);

  static rotation(radians: number): Mat2 {
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);

    return new Mat2(cos, sin, -sin, cos);
  }

  matMul(other: Mat2): Mat2 {
    return new Mat2(
        this.a * other.a + this.b * other.c,
        this.a * other.b + this.b * other.d,
        this.c * other.a + this.d * other.c,
        this.c * other.b + this.d * other.d,
    );
  }

  vecMul(other: Vec2): Vec2 {
    return new Vec2(
        this.a * other.x + this.b * other.y,
        this.c * other.x + this.d * other.y,
    );
  }
}
